import React from 'react'

import Avatars from 'components/Avatars'
import { thousandSeparator } from 'helpers/formatters'

import classes from './Reviewers.module.scss'

/** @type {import("./types").default} */
const Reviewers = ({ reviewers, totalReviewers }) => {
  return (
    <div className={classes.root}>
      <Avatars imagesUrl={reviewers.map(reviewer => reviewer.avatar.src)} imageSize={56} className={classes.avatars} />

      <div className={classes.text}>
        To determine these pros and cons insights, we analyzed responses from {thousandSeparator(totalReviewers)}{' '}
        verified reviews
      </div>
    </div>
  )
}

export default Reviewers
